// extracted by mini-css-extract-plugin
module.exports = {"management":"Management_management__abFny","filterBox":"Management_filterBox__2YKsU","locations":"Management_locations__10KGj"};